import React, { useEffect, useRef, useState } from "react";
import "./orderModal.css";
import emailjs from "emailjs-com";
import Filter from "bad-words";

export default function OrderModal({ open, onClose, service }) {
    const dialogRef = useRef(null);
    const formRef = useRef(null);
    const [sending, setSending] = useState(false);
    const [status, setStatus] = useState("");

    const filter = new Filter();


    // close on Esc
    useEffect(() => {
        const onKey = (e) => open && e.key === "Escape" && onClose();
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open, onClose]);

    // focus first input when opened
    useEffect(() => {
        if (open && dialogRef.current) {
            const first = dialogRef.current.querySelector("input,select,textarea,button");
            first?.focus();
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
    }, [open]);

    const submit = async (e) => {
        e.preventDefault();
        setStatus("");

        if (e.target.message.value.length < 20) {
            setStatus("Please add some project details.");
            return;
        }

        try {
            if (!filter.isProfane(e.target.message.value)) {
                setSending(true);
                await emailjs.sendForm(
                    "service_psabp8k",
                    "template_bdps3l3",
                    formRef.current,
                    "DjbuLLSBCv_PY31x9"
                );
                setStatus("Thanks! Your order request has been sent.");
                e.target.reset();
            } else {
                setStatus("Oops! Your message contains inappropriate language. Please rephrase politely.");
            }
        } catch (err) {
            setStatus("Oops, something went wrong. Please try again or use the Contact page.");
        } finally {
            setSending(false);
        }
    };

    if (!open) return null;

    return (
        <div className="om_backdrop" role="presentation" onMouseDown={onClose}>
            <div
                className="om_dialog"
                role="dialog"
                aria-modal="true"
                aria-labelledby="order-title"
                ref={dialogRef}
                onMouseDown={(e) => e.stopPropagation()}   // keep clicks inside
            >
                <div className="om_header">
                    <h3 id="order-title">Order — {service}</h3>
                    <button className="om_close" onClick={onClose} aria-label="Close">✕</button>
                </div>

                <form ref={formRef} onSubmit={submit} className="om_form">
                    {/* include selected service */}
                    <input type="hidden" name="service" value={service || ""} />

                    <div className="om_row">
                        <div className="om_field">
                            <label htmlFor="om_name">Full name</label>
                            <input id="om_name" name="name" type="text" required placeholder="Your Full Name" />
                        </div>
                        <div className="om_field">
                            <label htmlFor="om_email">Email</label>
                            <input id="om_email" name="email" type="email" required placeholder="your@email.com" />
                        </div>
                    </div>

                    <div className="om_row">
                        <div className="om_field">
                            <label htmlFor="om_timeline">Timeline</label>
                            <select id="om_timeline" name="timeline" defaultValue="" required>
                                <option value="" disabled hidden>Select a timeline</option>
                                <option>ASAP (1–3 days)</option>
                                <option>Within 1 week</option>
                                <option>1–2 weeks</option>
                                <option>2–4 weeks</option>
                                <option>Flexible / not sure</option>
                            </select>
                        </div>
                    </div>

                    <div className="om_field">
                        <label htmlFor="om_message">Project details</label>
                        <textarea id="om_message" name="message" rows="7" required
                                  placeholder="Description, info, references..."/>
                    </div>

                    <div className="om_actions">
                        <button type="submit" className="btn btn-primary" disabled={sending}>
                            {sending ? "Sending…" : "Send order request"}
                        </button>
                    </div>

                    {status && <div className="om_status">{status}</div>}
                </form>
            </div>
        </div>
    );
}
